import styled from '@emotion/styled'

import { Toast } from './Toast'
import {
  ToasterContextProvider,
  useToasterContext,
} from './ToasterContextProvider'
import { theme } from '../../constants'

const ToasterElement = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gridGap: 16,
  position: 'fixed',
  top: 16,
  left: 0,
  right: 0,
  padding: 16,
  pointerEvents: 'none',
  zIndex: theme.zIndex.toast,
})

export const Toaster = () => {
  const { removeToast, toasts } = useToasterContext()

  if (!toasts.length) {
    return null
  }

  return (
    <ToasterElement>
      {toasts.map((toast) => (
        <Toast
          {...toast}
          key={toast.id}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </ToasterElement>
  )
}

export { ToasterContextProvider, useToasterContext }
